export const DEFAULT_PAGE_WHEN_USER_IS_AUTHENTICATED = '/case';
